import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  OnChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViaSupportService } from '../../../services/support/via-support/via-support.service';
import { ViaName } from '@web/dtos';

@Component({
  selector: 'aw-via-chip',
  imports: [CommonModule],
  templateUrl: './via-chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViaChipComponent implements OnChanges {
  private viaService: ViaSupportService = inject(ViaSupportService);
  public readonly via: InputSignal<ViaName[]> = input.required();
  public viaAriaLabel: string = '';

  ngOnChanges(): void {
    this.viaAriaLabel = this.viaService.buildViaString(this.via());
  }
}
